import styled from 'styled-components'
import { BaseRow, BasePlaceholderRow } from '../BaseRow'

const USER_PERMISSIONS_ROW_HEIGHT = 56

export const BaseUserPermissionRow = styled(BaseRow)`
  height: ${USER_PERMISSIONS_ROW_HEIGHT}px;
`

export const UserPermissionRowPlaceholder = styled(BasePlaceholderRow).attrs({
  height: USER_PERMISSIONS_ROW_HEIGHT,
  pt: 0,
  pb: 0,
})``
